export const name = '@rails-resource';
